export enum SchedulerEndType {
	NoEndDate = 1,
	EndAfter = 2,
	EndDate = 3
}